// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import ChatController from "./chat_controller"
application.register("chat", ChatController)

import ConversationTitleController from "./conversation_title_controller"
application.register("conversation-title", ConversationTitleController)

import AdminSidebarController from "./admin_sidebar_controller"
application.register("admin-sidebar", AdminSidebarController)

import AgentDirectoryController from "./agent_directory_controller"
application.register("agent-directory", AgentDirectoryController)

import OdUiController from "./od_ui_controller"
application.register("od-ui", OdUiController)

import PaymentController from "./payment_controller"
application.register("payment", PaymentController)

import WechatLoginController from "./wechat_login_controller"
application.register("wechat-login", WechatLoginController)
